module.exports = __webpack_public_path__ + "images/mobile/img-empty-todo-4560cb1fd36195df76a1ee99ff7915dc.png";